import { Body, Controller, Post } from "@nestjs/common";
import { DateValidDumpModel } from "./dto/date-valid-dump.model";
// import { CreateLedgerExcelUploadDto } from "./dto/create-ledgerexcelupload.dto";
// import { ExcelDumpModel } from "./dto/excel-dump.model";
import { ExcelUploadService } from "./excel-upload.service";

@Controller('excel')
export class ExcelUploadController {
    constructor(private readonly exceluploadservice: ExcelUploadService) { }

    @Post('excelDump')
    async excelDump(@Body() payload: any) {
        return await this.exceluploadservice.excelDump(payload);
    }

    @Post('dateValidDump')
    async dateValidDump(@Body() dateValidate: any) {
        return await this.exceluploadservice.dateValidDump(dateValidate)
    }

}
